import { Box, Breadcrumbs, Link, makeStyles, Typography } from "@material-ui/core";
import { TEXT } from "Clients/ACCB/ACCBTheme";
import React, { useEffect, useState } from "react";
import Report from "./Report";
import { KeyboardBackspace, NavigateNext } from "@material-ui/icons";
import BacArbitratorReport from "./BacArbitratorReport";
import BacPendingReport from "./BacPendingReport";
import BacDisposalReport from "./BacDisposalReport";
import BacCauseListReport from "./BacCauseListReport";
import BacFinalAwardReport from "./BacFinalAwardReport";
import BacUndatedReport from "./BacUndatedReport";
import BacSlotAvailabilityReport from "./BacSlotAvailabilityReport";

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		boxSizing: 'border-box',
	},
	entryForm: {
		width: '70%',
		margin: 'auto',
		// The 70% width and 6rem side padding left the dropdown about 63px wide
		// on phones
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
	},
	paper: {
		padding: `3rem 6rem`,
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
		marginBottom: theme.spacing(4),
		borderRadius: '0.625rem',
	},
	button: {
		minWidth: '12rem',
	},
	reportCard: {
		backgroundColor: 'white',
		padding: '3rem 6rem',
		borderRadius: '0.625rem',
		[theme.breakpoints.down('xs')]: {
			padding: '1.5rem 1rem',
		},
	},
	reportActions: {
		display: 'flex',
		justifyContent: 'center',
		marginTop: '1rem',
	},
	formHeading: {
		fontSize: '1.375rem',
		fontWeight: 600,
		color: theme.palette.primary.main,
		textAlign: 'left',
	},
	label: {
		color: TEXT.strong,
		fontSize: '0.875rem',
		fontWeight: 500,
		lineHeight: '1.3125rem',
		textAlign: 'left',
		marginBottom: '0.2rem',
	},
}));

export default function ReportContainer() {
	const classes = useStyles();
	const [searchReport, setSearchReport] = useState('report');
	const [subScreen, setSubScreen] = useState(null);

	useEffect(() => {

	}, [])

	const RenderReports = ({ selected }) => {
		switch (selected) {
			case 'report':
				return <Report classes={classes} REPORT_CHOICES={REPORT_CHOICES} handleClickSearch={handleClickSearch} />
			case 'Cause List Report':
				return <BacCauseListReport />
			case 'Arbitrator Report':
				return <BacArbitratorReport />
			case 'Disposal Report':
				return <BacDisposalReport />
			case 'Pending Report':
				return <BacPendingReport />
			case 'Final Award Report':
				return <BacFinalAwardReport />
			case 'Undated Cases Report':
				return <BacUndatedReport />
			case 'Slot Availability Report':
				return <BacSlotAvailabilityReport />
			default:
				return <h1>Invalid Choice</h1>
		}
	};

	const REPORT_CHOICES = [
		'Cause List Report',
		'Arbitrator Report',
		'Disposal Report',
		'Pending Report',
		'Final Award Report',
		'Undated Cases Report',
		'Slot Availability Report',
	];

	const handleClickSearch = (newValue) => {
		setSearchReport(newValue);
	};

	const handleGoBack = (newValue) => {
		setSearchReport(newValue);
	}

	return (
		<Box className={classes.root}>
			{(searchReport !== 'report') && (
				<Box style={{ display: 'flex', paddingBottom: '1.5rem', gap: '10px' }}>
					<Typography style={{ cursor: 'pointer' }} onClick={() => { handleGoBack('report') }}>
						<KeyboardBackspace />
					</Typography>
					<Breadcrumbs separator={<NavigateNext fontSize="small" />} aria-label="breadcrumb">
						<Link color="inherit" style={{ cursor: 'pointer' }} onClick={() => { handleGoBack('report') }}>
							Report
						</Link>
						<Typography color="textPrimary">{searchReport}</Typography>
					</Breadcrumbs>
				</Box>
			)}
			<RenderReports selected={searchReport} />
		</Box>
	)
}
